// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605141233/js/" + chunkId + "." + {"44":"e5bbc966","225":"57e3c66a","481":"c545c1e5","486":"ba78410d","770":"f6f0c354"}[chunkId] + ".0.5090733587889151.chunk.js";
};